import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { regionChange } from '../../actions';
import { Dropdown } from '../../components/Dropdown';
import { getFilterRegionId } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { addQueryParameter } from '../../utils';
import { getRegions as getRegionsV2 } from '../../selectors/developerV2/getRegions';

export function RegionDropdown() {
  const dispatch: TThunkDispatch = useDispatch();
  const regions = useSelector(getRegionsV2);

  const regionsOptions = React.useMemo(() => {
    return regions.map(region => ({ label: region.name, value: region.id }));
  }, [regions]);

  const selectedRegion = useSelector(getFilterRegionId);

  const handleRegionChange = React.useCallback(
    (regionId: number) => {
      const url = regions.find(region => region.id === regionId)?.developerCardUrl;

      if (url) {
        document.location.replace(`${url}#projects`);

        return;
      }

      dispatch(regionChange(regionId));
      addQueryParameter('regionId', String(regionId));
    },
    [dispatch, regions],
  );

  return (
    <Dropdown
      label="Регион"
      dataTestId="RegionFilterDropdown"
      options={regionsOptions}
      selected={selectedRegion}
      onChange={handleRegionChange}
    />
  );
}
